import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button, Stack } from '@mui/material';

import { useReportIssuesFormManagement } from '../hooks';
import { FormTextField, BackdropLoading, FormSelectField } from '../components';
import { MessageModal } from '../modals';
import { changeActiveMenuItem, selectIsAuthenticated } from '../redux';

const keyPrefix = 'forms.ReportIssuesForm';

export const ReportIssuesForm: FC = (): JSX.Element => {
  const isAuth = useSelector(selectIsAuthenticated);
  const navigation = useNavigate();
  const { t } = useTranslation('translation', { keyPrefix });
  const [showErrorMessage, setShowErrorMessage] = useState<boolean>(false);
  const {
    canShowSendButton,
    genericErr,
    loading,
    methods,
    response,
    success,
    submit,
  } = useReportIssuesFormManagement();
  const dispatch = useDispatch();

  const goHome = (): void => {
    isAuth
      ? dispatch(changeActiveMenuItem({ activePage: 'home' }))
      : navigation('/login');
  };

  useEffect(() => {
    !!genericErr && setShowErrorMessage(true);
  }, [genericErr]);

  return (
    <>
      {!!response && (
        <MessageModal
          message={response}
          okLabel={t('modals.genericErr.ok')}
          title={success ? t('modals.success.title') : null}
          onClickOk={goHome}
          onClose={() => {
            setShowErrorMessage(false);
          }}
          showOkIcon
        />
      )}
      {showErrorMessage && (
        <MessageModal
          message={genericErr!}
          okLabel={t('modals.genericErr.ok')}
          onClickOk={() => {
            setShowErrorMessage(false);
          }}
          onClose={() => {
            setShowErrorMessage(false);
          }}
        />
      )}
      {loading && <BackdropLoading />}
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(submit)}>
          <Stack spacing={2} pt={3}>
            <FormSelectField
              name='categoryDescription'
              label={t('categoryDescription.label')}
              inputProps={{ maxLength: 50 }}
              values={[
                { value: t('categoryDescription.values.1'), label: t('categoryDescription.values.1') },
                { value: t('categoryDescription.values.2'), label: t('categoryDescription.values.2') },
                { value: t('categoryDescription.values.3'), label: t('categoryDescription.values.3') },
                { value: t('categoryDescription.values.4'), label: t('categoryDescription.values.4') },
                { value: t('categoryDescription.values.5'), label: t('categoryDescription.values.5') },
              ]}
              // defaultValue='1'
            />
            <FormTextField
              name='email'
              label={t('email.label')}
              inputProps={{ maxLength: 50 }}
            />
            <FormTextField
              name='comments'
              label={t('comments.label')}
              inputProps={{ maxLength: 50 }}
              isTextArea={true}
            />

            <Stack direction='row' pt={4} spacing={2}>
              <Button
                type='submit'
                variant='contained'
                disabled={!canShowSendButton}
                fullWidth
              >
                {t('submit.label')}
              </Button>
            </Stack>
          </Stack>
        </form>
      </FormProvider>
    </>
  );
};
